import { getQueryKeyForInternal } from 'state/utils/getQueryKeyForInternal';

// this variant ID uses the full GUID (ie "gid://shopify/ProductVariant/[variant_id]")
export const getQueryKeyForNextOrderAddableSubscriptionsV2 = (variantId: string) =>
  getQueryKeyForInternal({
    keys: ['next-order-addable-subscriptions-v2', variantId]
  });
